__turbopack_context__.v({
  "ctaCallLink": "_6DHxuW_ctaCallLink",
});
